import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
const API_V1_URL = `${API_BASE_URL}/v1`;

interface ParamsCTXRList {
    cloud?: string;
    region?: string;
}

export function getCTXRlistGlobal(
    subscriptionId: number,
    tenant: number,
    token: string,
    cloud?: string,
    region?: string
) {
    const params: ParamsCTXRList = {};
    if (cloud !== undefined) params.cloud = cloud;
    if (region !== undefined) params.region = region;

    return axios.get(
        `${API_V1_URL}/ctxr/${subscriptionId}/listSelector?tenantId=${tenant}`,
        {
            params,
            headers: { Authorization: `Bearer ${token}` },
        }
    );
}

// Ejemplo de función para pedir la lista de "available"
export function getAvailableSyslogs(
    subscriptionId: number,
    ctxrId: string,
    tenant: number,
    token: string
) {
    // https://stg-api.transitxchange.cloud/api/v1/serverlog/{subscriptionId}/available/{ctxrId}?tenantId={tenant}
    const url = `${API_V1_URL}/serverlog/${subscriptionId}/available/${ctxrId}?tenantId=${tenant}`;
    return axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

// Ejemplo de función para pedir la lista de "selected"
export function getSelectedSyslogs(
    subscriptionId: number,
    ctxrId: string,
    tenant: number,
    token: string
) {
    // https://stg-api.transitxchange.cloud/api/v1/serverlog/{subscriptionId}/ctxr/${ctxrId}?tenantId={tenant}
    const url = `${API_V1_URL}/serverlog/${subscriptionId}/ctxr/${ctxrId}?tenantId=${tenant}`;
    return axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

// POST para guardar cambios con el nuevo endpoint
export function saveSyslogs(
    subscriptionId: number,
    ctxrId: string,
    tenant: number,
    token: string,
    syslogs: SyslogItem[]
) {
    // Nuevo endpoint: POST /ctxr/associationwithsyslog/{ctxrId}?tenantId=...
    const url = `${API_V1_URL}/ctxr/associationwithsyslog/${ctxrId}?tenantId=${tenant}`;

    // Armamos el payload como [ { "id": x, "level": y }, ... ]
    const payload = syslogs.map(({ id, level }) => ({
        id,
        level: level ?? 0,
    }));

    return axios.post(url, payload, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

// Tipifica tu SyslogItem según el response real
export interface SyslogItem {
    id: number;
    ip: string;
    port: number;
    description: string;
    level?: number;
}
